// extracted by css-extract-rspack-plugin
export default {"card":"card-g3Ephx"};